export type Speaker = 'provider' | 'patient';
export type CueKind = 'assessment' | 'thought';

export interface ThoughtIdentityConfig {
  anchors: Record<string, { u: number; v: number; width: number }>;
  sounds: { duration: number; amplitude: number; provider: number[]; patient: number[] };
}

export interface ExperienceCue {
  id: string;
  kind: CueKind;
  speaker?: Speaker;
  start: number;
  end: number | null;
  title: string;
  summary: string;
  scriptAnchor?: string;
  holdFrame: string;
  replacementVideo?: string | null;
  timingStatus?: string;
  anchor?: { yawDeg: number; pitchDeg: number };
}

export interface Chapter {
  id: string;
  at: number;
  eyebrow: string;
  label: string;
}

export interface ExperienceManifest {
  schemaVersion: number;
  id: string;
  title: string;
  subtitle: string;
  attribution: string;
  media: {
    master: string;
    sourceMaster: string;
    poster: string;
    projection?: 'rectilinear' | 'equirectangular';
    sourceFieldOfView?: {
      horizontalDegrees: number;
      verticalDegrees: number;
      yawDegrees: number;
      pitchDegrees: number;
    };
    clock: 'master';
    audioPolicy: 'embedded';
    durationSeconds: number;
    nominalFrameRate: string;
    captions?: { vtt: string; status: 'draft' | 'reviewed'; language: string };
  };
  rooms: Array<{ id: string; label: string; enabled: boolean; startAt?: number; state?: string }>;
  chapters: Chapter[];
  cues: ExperienceCue[];
}

export function activeCueAt(manifest: ExperienceManifest, time: number): ExperienceCue | null {
  return manifest.cues.find((cue) => time >= cue.start && time < (cue.end ?? manifest.media.durationSeconds + 1)) ?? null;
}

export function activeChapterAt(manifest: ExperienceManifest, time: number): Chapter {
  let current = manifest.chapters[0];
  for (const chapter of manifest.chapters) if (time >= chapter.at) current = chapter;
  return current;
}
